import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { PutCoveragesFailure, PutCoveragesRequest, PutCoveragesReset, PutCoveragesSuccess } from './actions';
import { Coverage } from '@models/swagger';

export const featureKey = 'putCoverages';

export interface State {
  data: Coverage[] | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: [],
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(PutCoveragesFailure, (state, { error }) => ({ ...state, data: [], error, loading: false })),
    on(PutCoveragesRequest, state => ({ ...state, error: null, loading: true })),
    on(PutCoveragesSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false })),
    on(PutCoveragesReset, state => ({ ...state, data: [], error: null, loading: false }))
  )(state, action);
}
